// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, maybe, objectOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

const isCustomObjectTypeSchemaDef = objectOf({
  type: string,
  properties: objectOf({}),
  required: maybe(arrayOf(string)),
});

export const isGetCustomObjectsUserRelationshipTypeSchemaResult = objectOf({
  type_name: string,
  rel_kind: string,
  schema_def: isCustomObjectTypeSchemaDef,
});
